// locale for flappy

import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

let locale = safeLoadLocale('flappy_locale');
module.exports = locale;
